"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.delete.confirm.title': 'Delete Profession',
    'profession.delete.confirm.message': 'Are you sure you want to delete this profession?',
};
